import React, {Component} from "react";
import GlobalSearchResult from "./GlobalSearchResult";
import PropTypes from "prop-types";
import {List as ImmutableList} from 'immutable';
import Pagination from './Pagination';

import "./GlobalSearchResults.css"

class GlobalSearchResults extends Component {

	state = {
		resultsPaginated: [],
		paginateBy: 10,
		numberOfPages: null,
		currentPage: 0,
		firstRun: true
	};

	componentDidMount(){}

    componentDidUpdate(prevProps, prevState) {
		const {searchResults, globalSearchFilter} = this.props;
        const {paginateBy, currentPage, firstRun} = this.state;

		if(prevProps !== this.props){
			const numberOfPages = Math.ceil(searchResults.size/paginateBy);
            let resultsPaginated = [];
            let k = 0;
            let i,j,tempArray,chunk = paginateBy;
            for (i=0,j=searchResults.size; i<j; i+=chunk) {
                tempArray = searchResults.slice(i,i+chunk);
                resultsPaginated[k] = tempArray;
                k++;
            }
            this.setState({
                numberOfPages,
                resultsPaginated,
                currentPage: prevProps.globalSearchFilter === globalSearchFilter ? currentPage : 0
            });
		}
		if(!firstRun){
            const element = document.getElementsByClassName('globalsearchfield')[0];
            element.scrollIntoView({behavior: 'smooth'});
		}
    }

    setCurrentPage = (currentPage) => {
		this.setState({currentPage, firstRun: false})
	};

	buttonClickCallback = (page) =>{
        this.setCurrentPage(page - 1);
	};

	render() {
		const {numberOfPages, currentPage, resultsPaginated}= this.state;
		const {searchResults} = this.props;
		let isActive = searchResults.size > 0;

		return (
			<div>
                <section className={"globalsearchresults-paginationwrapper"}>
                    <Pagination numberOfPages={numberOfPages} currentPage={currentPage + 1} callback={this.buttonClickCallback} numberOfButtons={5}/>
                </section>
				<section id="searchresultscontainer" className="globalsearchresults" data-stateactive={isActive}>
					<ul className="globalsearchresults-list">

						{!!resultsPaginated.length && resultsPaginated[currentPage].map( (item, index)=>{

								return (
									<GlobalSearchResult
										key={index}
										link={item.get("link")}
										type={item.get("type")}
										title={item.get("title")}
										description={item.get("description")}
										image={item.get("image")}
									/>
								)
							})
						}
					</ul>
				</section>

				<section className={"globalsearchresults-paginationwrapper"}>
					<Pagination numberOfPages={numberOfPages} currentPage={currentPage + 1} callback={this.buttonClickCallback} numberOfButtons={5}/>
				</section>
			</div>
		)
	}
}
GlobalSearchResults.propTypes = {
	searchResults: PropTypes.object
}
GlobalSearchResults.defaultProps = {
	searchResults: ImmutableList()
}

export default GlobalSearchResults;



// WEBPACK FOOTER //
// ./src/js/components/GlobalSearchResults.js